import { render } from "./CambioClaveUsuarioForm.vue?vue&type=template&id=b3d253dc&scoped=true"
import script from "./CambioClaveUsuarioForm.vue?vue&type=script&lang=js"
export * from "./CambioClaveUsuarioForm.vue?vue&type=script&lang=js"

import "./CambioClaveUsuarioForm.vue?vue&type=style&index=0&id=b3d253dc&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d253dc"]])

export default __exports__